import { getProfile } from '@/api/profile';
import { getSiteBuildState } from '@/api/sites';

/**
 * Query options for the Dashboard's profile and build-state reads, one cache entry each. (The setup
 * checklist is its own single read now, GET /setup/checklist, built by the gateway.)
 */
export const profileQuery = () => ({
  queryKey: ['profile'] as const,
  queryFn: getProfile,
  staleTime: 5 * 60_000,
});

/** Keyed by the site: switching sites must not keep the last site's answer. */
export const buildStateQuery = (siteId: string | null) => ({
  queryKey: ['site-build-state', siteId] as const,
  queryFn: getSiteBuildState,
  staleTime: 60_000,
  retry: 1,
});
